import { AsyncState, loadingAsyncState, unloadedAsyncState } from "widgets-for-react"
import { getCollectionPage } from "../../../../custom_api/api"
import { fetchPopularThemePrompts, TextWith4Covers } from "../../../../custom_api/collection/api"
import { CollectionPageProps } from "../../../pages/collection_page"
import { SearchOn } from "../../../../custom_api/collection/types"

export interface ThemeBasedInspirationState {
  collectionPage: AsyncState<CollectionPageProps>
  popularThemes: AsyncState<TextWith4Covers[]>
  routePath: string,
  isKioskMode: boolean
  searchQuery: string
  searchResults: AsyncState<SearchOn[]>
}

export const initialThemeBasedState: ThemeBasedInspirationState = {
  collectionPage: loadingAsyncState(() => getCollectionPage()),
  popularThemes: loadingAsyncState(fetchPopularThemePrompts),
  routePath: '',
  isKioskMode: false,
  searchQuery: '',
  searchResults: unloadedAsyncState()
}

export type ThemeBasedInspirationLayoutProps = ThemeBasedInspirationState & {
  updateSearchQuery: (query: string) => void
  pickTheme: (book: SearchOn) => void
  pushDataLayer: (action: string, label: string) => void
}
